import { render } from "./PageHeader.vue?vue&type=template&id=84956f3a&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"

import "./PageHeader.vue?vue&type=style&index=0&id=84956f3a&scoped=true&lang=css"

import exportComponent from "/builds/kmkn5581/messequiz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84956f3a"]])

export default __exports__